import React from "react";
const Configurations = () => {
  return <h1>Configurations</h1>;
};
export default Configurations;
